import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { CriticityComponent } from '@camelot/ui';

import { SwitchCasesCriticityChanged } from '../../../../../services/dto/switch-cases';
import { SwitchCaseBaseComponent } from '../switch-case-base/switch-case-base.component';

@Component({
  selector: 'cam-switch-cases-criticity-changed',
  templateUrl: './switch-cases-criticity-changed.component.html',
  styleUrls: ['./switch-cases-criticity-changed.component.scss'],
  imports: [TranslatePipe, CriticityComponent],
})
export class SwitchCasesCriticityChangedComponent extends SwitchCaseBaseComponent<SwitchCasesCriticityChanged> {}
